// Your reducer weekPaginationSlice

import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import dayjs, { Dayjs } from "dayjs"

export interface IWeekPagination {
  currentWeek: string // Store currentWeek as a string (formatted date)
}

const weekPaginationState: IWeekPagination = {
  currentWeek: dayjs().format("YYYY-MM-DD"), // Use a format that ensures correct parsing
}

const weekPaginationSlice = createSlice({
  name: "weekPagination",
  initialState: weekPaginationState,
  reducers: {
    setWeekPaginationState: (state, action: PayloadAction<Dayjs | string>) => {
      // Convert Dayjs to string before updating the state
      state.currentWeek =
        typeof action.payload === "string"
          ? action.payload
          : dayjs(action.payload).format("YYYY-MM-DD")
    },
  },
})

export const weekPaginationReducer = weekPaginationSlice.reducer
export const { setWeekPaginationState } = weekPaginationSlice.actions
